// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper__Sjioc","small":"Button_small__1WqE1","disabled":"Button_disabled__1f6YP"};